import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import {
  CategoryType,
  Coupons,
  storeDetailType,
  storeType,
} from "../../controller/StoreController";
import MenuInfo from "./menuInfoWide";

import toast from "react-hot-toast";
import Slider from "react-slick";
import { useRecoilValue } from "recoil";
import { getRecoil } from "recoil-nexus";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import CouponListModal from "../../components/modal/CouponListModal";
import {
  ContentStoreDataType,
  STORE_CLOSE,
  STORE_OPEN,
} from "../../controller/MasterController";
import { useToast } from "../../controller/ToastController";
import { masterStoreState, qrAuthState, qrAuthType } from "../../recoil/auth";
import { cartProductQuantityState, cartState } from "../../recoil/cart";
import { langState, langText } from "../../recoil/lang";
import { orderDetailRealmType } from "../../recoil/type";
import { getStoreName } from "../../utils/util";
import {
  UseQueryResult,
  useQueries,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import AsyncLocalStorage from "../../utils/AsyncLocalStorage";
import GuideModal from "../../components/modal/GuideModal";
import LogController from "../../controller/LogController";

type storeDataType = {
  store: storeType;
  menu: CategoryType[];
  detail: storeDetailType[];
  coupons: Coupons[];
};

const StoreDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const auth: qrAuthType = useRecoilValue(qrAuthState);

  const currentDate = new Date();

  const storeList = location.state.storeList;
  const selectedIndex: number = location.state.storeIndex;
  const sliderRef = useRef<Slider>(null);

  const queryClient = useQueryClient();

  const showToast = useToast();
  const lang = useRecoilValue<number>(langState);
  const cartQuantitiy = useRecoilValue(cartProductQuantityState);

  // 쿠폰리스트모달
  const [visibleCouponListModal, setVisibleCouponListModal] =
    useState<boolean>(false);

  const [storeId, setStoreId] = useState<number>(0);

  const [selectedStoreIndex, setSelectedStoreIndex] =
    useState<number>(selectedIndex);

  const cart = useRecoilValue<orderDetailRealmType[]>(cartState);

  const [scrollTop, setScrollTop] = useState<boolean>(false);

  const [visibleGuide, setVisibleGuide] = useState<boolean>(false);

  const navigateMaster = () => {
    navigate(`/master`);
  };

  const navigatePayment = async () => {
    try {
      LogController.click({
        path: "CartInfo",
        params: "click",
        params2: "주문하기 버튼 클릭",
        index: cart.length > 0 ? cart[0].store_id : 0,
      });
    } catch (err) {
      console.log(err);
    }

    if (storeData && storeData.store.store_availability_yn) {
      if (cart.length > 0) {
        navigate("/payment", {
          state: { storeName: storeData.store.store_name },
        });
      } else {
        showToast(langText.confirmModal_cart[lang], "error");
      }
    } else {
      showToast(langText.confirmModal_closed[lang], "error");
    }
  };

  //매장정보, 메뉴정보 가져오기
  // const getStoreData = async (store_id: number) => {
  //   try {
  //     // const res = await StoreController.getMenuByStoreLoginId(id!);
  //     const res = await ApiController.store.getKnockStoreData({
  //       store_id,
  //       parent_store_id: getRecoil(masterStoreState).store_id,
  //       user_token_id: auth.user_token_id,
  //       user_id: auth.user_id,
  //     });

  //     // if (res.ok) {
  //     //   console.log("getKnockStoreData", res.data);
  //     //   setStoreInfo(res.data.store);
  //     //   setMenuInfo(res.data.menu);
  //     //   setStoreDetailInfo(res.data.detail);
  //     //   setCoupons(res.data.coupons);
  //     // }
  //     console.log("getKnockStoreData", res.data);

  //     return res.data;
  //   } catch (err) {
  //     console.log("getStoreData err-->", err);
  //   }
  // };

  const { data: storeData }: UseQueryResult<storeDataType> = useQuery({
    queryKey: [
      "details",
      "store_id" in storeList
        ? storeList.store_id
        : storeList[selectedStoreIndex].store_id,
    ],
    queryFn: async () => {
      const res = await ApiController.store.getKnockStoreData({
        store_id: storeId,
        parent_store_id: getRecoil(masterStoreState).store_id,
        user_token_id: auth.user_token_id,
        user_id: auth.user_id,
      });
      if (res && res.data && res.data.data) {
        return res.data.data;
      } else throw new Error("details error");
    },
    enabled: false,
  });

  const onClickStoreItem = (storeId: number, index: number) => {
    setScrollTop(true);
    setSelectedStoreIndex(index);
    queryClient.prefetchQuery({
      queryKey: ["details", storeId],
      queryFn: async () => {
        const res = await ApiController.store.getKnockStoreData({
          store_id: storeId,
          parent_store_id: getRecoil(masterStoreState).store_id,
          user_token_id: auth.user_token_id,
          user_id: auth.user_id,
        });
        if (res && res.data && res.data.data) {
          return res.data.data;
        } else throw new Error("details error");
      },
    });
    setStoreId(storeId);
    // console.log(index);
    sliderRef.current?.slickGoTo(
      (index - 1) % (storeList as ContentStoreDataType[]).length
    );
  };
  const onClickArrow = (index: number) => {
    const slickIndex =
      index < 0
        ? 0
        : index >= (storeList as ContentStoreDataType[]).length
        ? (storeList as ContentStoreDataType[]).length - 1
        : index % (storeList as ContentStoreDataType[]).length;

    setSelectedStoreIndex(slickIndex);
    console.log("slickIndex", slickIndex);
    sliderRef.current?.slickGoTo(slickIndex);
  };

  const checkOpenClosingTime = (data: storeType) => {
    if (data.next_close_time && data.next_open_time) {
      const closeHours = new Date(data.next_close_time).getHours();
      const closeMinutes = new Date(data.next_close_time).getMinutes();

      const openHours = new Date(data.next_open_time).getHours();
      const openMinutes = new Date(data.next_open_time).getMinutes();

      if (
        closeHours * 60 +
          closeMinutes -
          (currentDate.getHours() * 60 + currentDate.getMinutes()) <
          60 &&
        closeHours * 60 +
          closeMinutes -
          (currentDate.getHours() * 60 + currentDate.getMinutes()) >
          0
      )
        return {
          status: STORE_CLOSE,
          time:
            closeHours * 60 +
            closeMinutes -
            (currentDate.getHours() * 60 + currentDate.getMinutes()),
        };

      if (
        openHours * 60 +
          openMinutes -
          (currentDate.getHours() * 60 + currentDate.getMinutes()) <
          60 &&
        openHours * 60 +
          openMinutes -
          (currentDate.getHours() * 60 + currentDate.getMinutes()) >
          0
      )
        return {
          status: STORE_OPEN,
          time:
            openHours * 60 +
            openMinutes -
            (currentDate.getHours() * 60 + currentDate.getMinutes()),
        };
    }
    return {
      status: "",
      time: 100,
    };
  };

  useEffect(() => {
    try {
      LogController.navigate({
        path: "StoreDetails",
        params: "navigate",
        params2: "매장상세",
        store_id:
          "store_id" in storeList
            ? storeList.store_id
            : storeList[selectedIndex].store_id,
        index:
          "store_id" in storeList
            ? storeList.store_id
            : storeList[selectedIndex].store_id,
      });
    } catch (err: any) {
      console.log(err);
    }

    setStoreId(
      "store_id" in storeList
        ? storeList.store_id
        : storeList[selectedIndex].store_id
    );

    const savedFlag = AsyncLocalStorage.getItem("guideFlag");
    console.log("savedFlag", savedFlag);
    if (savedFlag) {
      setVisibleGuide(true);
      AsyncLocalStorage.removeItem("guideFlag");
    }
  }, []);

  useEffect(() => {
    if (!storeData) {
      console.log("refetch");
      queryClient.fetchQuery({
        queryKey: [
          "details",
          "store_id" in storeList
            ? storeList.store_id
            : storeList[selectedStoreIndex].store_id,
        ],
      });
    }
  }, [storeData]);

  const CustomPrevArrow = (props: any) => {
    return (
      <div className="custom-arrow custom-next-arrow">
        <img
          className="arrow left"
          onClick={() => onClickArrow(selectedStoreIndex - 3)}
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_circle_left.svg`}
          alt="ic"
        />
      </div>
    );
  };

  const CustomNextArrow = (props: any) => {
    return (
      <div className="custom-arrow custom-prev-arrow">
        <img
          className="arrow right"
          onClick={() => onClickArrow(selectedStoreIndex + 3)}
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_circle_right.svg`}
          alt="ic"
        />
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 100,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerPadding: "0",
    draggable: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  return (
    <>
      <Style>
        <div className="wrap">
          <div className="container">
            <div className="header">
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_home.svg`}
                onClick={navigateMaster}
                alt="뒤로가기"
                className="backBtn"
              />
              {"store_id" in storeList || storeList.length === 1 ? (
                <h2 className="storeName">
                  {"store_id" in storeList
                    ? getStoreName(storeList, lang)
                    : getStoreName(storeList[0], lang)}
                </h2>
              ) : (
                <Slider ref={sliderRef} className="slider" {...settings}>
                  {storeList.map(
                    (item: ContentStoreDataType, index: number) => {
                      return (
                        <div
                          key={index}
                          className="storeItem"
                          onClick={() => onClickStoreItem(item.store_id, index)}
                        >
                          <img
                            src={item.store_img_url}
                            className={`${
                              selectedStoreIndex === index && "active"
                            }`}
                            alt="img"
                          />
                          <div className="storeTitle">
                            <p>{getStoreName(item, lang)}</p>
                          </div>
                        </div>
                      );
                    }
                  )}
                </Slider>
              )}
              {/* <button className="zoom" onClick={handleToggleZoom}>
                {zoom ? (
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/zoomOut.svg`}
                    alt="메뉴 확대"
                  />
                ) : (
                  <img
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/zoomIn.svg`}
                    alt="메뉴 확대"
                  />
                )}
              </button> */}
              <div style={{ width: "26px" }} />
            </div>
            {storeData && storeData.coupons.length > 0 ? (
              <div className="slideWrap">
                <div
                  className="slideBadge"
                  onClick={() => setVisibleCouponListModal(true)}
                >
                  <p>
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star_white.svg`}
                      alt="별아이콘"
                    />
                    {langText.menuInfo_event[lang]}
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_star_white.svg`}
                      alt="별아이콘"
                    />
                    {getStoreName(storeList, lang)} {langText.coupon[lang]} -
                    {storeData &&
                      storeData.coupons
                        .map((data) => data.coupon_name)
                        .join(", ")}
                    {langText.coupon_slider_notice[lang]}
                  </p>
                  <button>
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_storeCoupon.svg`}
                      alt="쿠폰아이콘"
                    />
                    {langText.coupon_view[lang]}
                  </button>
                </div>
              </div>
            ) : (
              <div className="slideWrap" />
            )}
            {storeData ? (
              <MenuInfo
                storeId={storeId}
                menuInfo={storeData && storeData.menu ? storeData.menu : []}
                storeInfo={
                  storeData && storeData.store ? storeData.store : undefined
                }
                storeDetailInfo={
                  storeData && storeData.detail ? storeData.detail : []
                }
                scrollTop={scrollTop}
                setScrollTop={setScrollTop}
                storeList={storeList}
              />
            ) : (
              <div className="loadingWrap">
                <img
                  src={`${process.env.PUBLIC_URL}/knockknock/gif/loadingImage.gif`}
                  alt="로딩이미지"
                />
              </div>
            )}
            <button
              className={`success ${
                (cart.length < 1 ||
                  (storeData &&
                    storeData.store &&
                    !storeData.store.store_availability_yn)) &&
                "unabled"
              }`}
              onClick={navigatePayment}
            >
              {storeData &&
              storeData.store &&
              !storeData.store.store_availability_yn ? (
                <h2>{langText.confirmModal_closed[lang]}</h2>
              ) : (
                <>
                  <h2>{langText.storeDetails_button_cart[lang]}</h2>
                  {cart.length > 0 && (
                    <div className="cartCount">
                      <p>{cartQuantitiy}</p>
                    </div>
                  )}
                </>
              )}
            </button>
          </div>
        </div>
      </Style>
      <CouponListModal
        isVisible={visibleCouponListModal}
        setVisible={setVisibleCouponListModal}
        coupons={storeData ? storeData.coupons : []}
        modalType="store"
      />
      <GuideModal isVisible={visibleGuide} setVisible={setVisibleGuide} />
    </>
  );
};
export default StoreDetails;

const Style = styled.div`
  .container {
    width: 100%;
    max-width: 100%;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    /* overflow: hidden; */
  }

  .header {
    height: auto;
    padding-top: 20px;
    margin: 0 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    .storeName {
      font-size: 20px;
      line-height: 28px;
      font-weight: 400;
    }
    .backBtn {
      width: 26px;
    }
    .zoom {
      padding: 0;
      img {
        height: 28px;
      }
    }
  }
  .slideWrap {
    display: flex;
    align-items: center;
    max-width: 100%;
    min-width: 100%;
    min-height: 24px;
    max-height: 24px;
    margin-top: 10px;
    overflow: hidden;
  }

  .slideBadge {
    background: #ffb800;
    height: 100%;
    border-radius: 50px;
    animation: slideIn 24s linear infinite;
    display: inline-flex;
    align-items: center;

    p {
      padding: 0 10px;
      font-size: 12px;
      line-height: 12px;
      font-weight: 500;
      color: #ffffff;
      white-space: nowrap;

      img {
        margin: 0 4px;
        width: 12px;
        height: 12px;
      }
    }
    button {
      display: flex;
      align-items: center;
      padding: 2px 12px;
      height: inherit;
      white-space: nowrap;
      background: #fff;
      color: #ffb800;
      border-radius: 50px;
      font-size: 12px;
      font-weight: 700;
      line-height: 12px;

      img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
      }
    }
  }
  .slideBadge.time {
    background: #ffba07;
  }

  @keyframes slideIn {
    0% {
      transform: translateX(120%);
    }

    100% {
      transform: translateX(-120%);
    }
  }

  // 매장 선택 화면
  .slider {
    width: 45vw;
    .arrow {
      position: absolute;
      width: 20px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }
    .arrow.left {
      left: -26px;
    }
    .arrow.right {
      right: -26px;
    }
  }
  .slick-track {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 4px;
  }
  .storeItem {
    min-width: calc((45vw - 12px) / 3);
    max-width: calc((45vw - 12px) / 3);
    display: flex;
    flex-direction: column;

    img {
      width: 100%;
      aspect-ratio: 1/0.9;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      object-fit: cover;
      filter: brightness(50%);
    }
    img.active {
      filter: brightness(100%);
    }
    .storeTitle {
      width: 100%;
      height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #5e5e5e;
      padding: 0 2px;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;

      p {
        color: #ffffff;
        font-size: 9px;
        line-height: 16px;
        font-weight: 300;
        margin: 0 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  button.success {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    padding: 12px;
    gap: 8px;
    border-radius: 5px;
    background: #4dd2ae;
    h2 {
      font-size: 20px;
      line-height: 28px;
      font-weight: 600;
    }
    .cartCount {
      width: 24px;
      height: 24px;
      text-align: center;
      background: #ffffff;
      border-radius: 50px;
      p {
        font-size: 14px;
        line-height: 24px;
        color: #4dd2ae;
        font-weight: 700;
      }
    }
  }
  button.success.unabled {
    background: #cecece;
  }

  .loadingWrap {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    img {
      width: 80%;
      object-fit: cover;
    }
  }
`;
